import { gql, useMutation } from '@apollo/client';

import { GET_HOLIDAY_LOCATIONS_BY_COMPANY } from './get-holiday-locations-by-company.hook';

export const CREATE_HOLIDAY_LOCATION = gql`
  mutation createHolidayLocation($payload: CreateHolidayLocationInput!) {
    createHolidayLocation(payload: $payload) {
      _id
    }
  }
`;

export const useCreateHolidayLocation = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createHolidayLocation] = useMutation(CREATE_HOLIDAY_LOCATION, {
    refetchQueries: [GET_HOLIDAY_LOCATIONS_BY_COMPANY],
    onCompleted: onSuccess,
  });

  return createHolidayLocation;
};
